import { createFileRoute } from "@tanstack/react-router";
import { SilverPage, silverRatesQO } from "@/components/SilverPage";
import { buildAliasHead } from "@/lib/alias-routes";

const TITLE = "Today's Live Silver Rate in Faisalabad — 1 Tola & 10 Gram Price";
const DESC = "Live silver / chandi rate in Faisalabad today — per tola, per 10 gram, per gram & per kg. Hourly auto-update from international XAG spot + USD/PKR FX.";

export const Route = createFileRoute("/silver-rate-faisalabad")({
  head: () => buildAliasHead({ title: TITLE, description: DESC, path: "/silver-rate-faisalabad" }),
  loader: ({ context }) => context.queryClient.ensureQueryData(silverRatesQO),
  component: () => (
    <SilverPage
      country="pakistan"
      cityName="Faisalabad"
      title="Today's Live Chandi (Silver) Rate in Faisalabad"
      intro="Live silver rate in Faisalabad — recalculated every 10 minutes from international XAG spot price and today's USD/PKR rate. Per tola, per 10 gram, per gram and per kilogram."
    />
  ),
});
